// extracted by mini-css-extract-plugin
export default {"thTable":"TransactionHistory_thTable__3GVVz"};